import React, {useEffect, useState} from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Grid, Button, Input, Dropdown, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {requestsDeviceType} from '../../../common/constants/lists';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import ReactTable from '../../../common/components/reactTable';
import ModalDeviceRequest from '../../components/RequestsInstallation/modal/deviceRequest';
import {columnsRequestDevice} from '../../constants';
import './requestDevice.scss';

const {
  navigateTo,
  fetchRequestsList,
  clearRequestsDeviceList,
  fetchAgenciesByDealer,
  fetchDealer,
} = Actions;

const RequestsInstallationDevice = () => {
  const [selectedFilters, setSelectedFilters] = useState({
    'startDate': '',
    'endDate': '',
    'requestType': '',
  });
  const {permissions, dealerId, isUserFromTDE} = useSelector((state) => state.session);
  const {loading, list} = useSelector((state) => state.requestsDevice);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.RequestsInstallationDevice, scopes.See) &&
      !hasAccessPermission(permissions, resources.RequestsInstallationDevice, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(clearRequestsDeviceList());
    dispatch(fetchDealer(dealerId));
    dispatch(fetchAgenciesByDealer({dealerId}));
  }, []);

  const handleSearchClick = () => {
    const params = isUserFromTDE ? selectedFilters : {...selectedFilters, dealerId};
    dispatch(fetchRequestsList(params));
  };

  const handleClearClick = () => {
    setSelectedFilters({'startDate': '', 'endDate': '', 'requestType': ''});
    dispatch(clearRequestsDeviceList());
  };

  const onChangeValues = (value, field) => {
    let finalValue = value;
    if (field !== 'requestType') {
      finalValue = value ? moment(value).format(noTimeZoneShortISODate) : '';
    }
    setSelectedFilters({...selectedFilters, [field]: finalValue});
  };

  const renderTable = () => {
    if (loading) {
      return (
        <Card raised fluid className="request-detail">
          <Loader active inline="centered">
            Procesando...
          </Loader>
        </Card>
      );
    }

    return <ReactTable list={list} columnsList={columnsRequestDevice} />;
  };

  return (
    <div className="devices-request">
      <Card raised fluid>
        <div className="title-bar">
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <div className="title">
                  <h2>Solicitudes de Reinstalación y Desinstalación</h2>
                </div>
              </Grid.Column>
              <Grid.Column textAlign="right" width={8} className="flex end">
                {!isUserFromTDE && (
                  <ModalDeviceRequest action="create" dealerId={dealerId} />
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Card raised fluid>
        <div className="filters-section">
          <Grid>
            <Grid.Row textAlign="left">
              <Grid.Column width={3}>
                <h4>Fecha inicio:</h4>
                <DatePicker
                  required
                  locale="es"
                  dateFormat={dateFormatPicker}
                  customInput={<Input readOnly icon="calendar" size="small" />}
                  selected={
                    selectedFilters.startDate ?
                      moment(
                        selectedFilters.startDate,
                        noTimeZoneShortISODate
                      ).toDate() :
                      null
                  }
                  onChange={(date) => onChangeValues(date, 'startDate')}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>Fecha fin:</h4>
                <DatePicker
                  required
                  locale="es"
                  customInput={<Input readOnly icon="calendar" size="small" />}
                  dateFormat={dateFormatPicker}
                  minDate={
                    selectedFilters.startDate ?
                      moment(
                        selectedFilters.startDate,
                        noTimeZoneShortISODate
                      ).toDate() :
                      null
                  }
                  selected={
                    selectedFilters.endDate ?
                      moment(
                        selectedFilters.endDate,
                        noTimeZoneShortISODate
                      ).toDate() :
                      null
                  }
                  onChange={(date) => onChangeValues(date, 'endDate')}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Tipo de solicitud:</h4>
                <Dropdown
                  selection
                  required
                  error={!selectedFilters.requestType}
                  options={requestsDeviceType}
                  name="request"
                  value={selectedFilters.requestType}
                  onChange={(e, {value}) =>
                    onChangeValues(value, 'requestType')
                  }
                  placeholder="Seleccione el tipo de solicitud"
                />
              </Grid.Column>
              <Grid.Column width={6} textAlign='right'>
                <div className="btn-column">
                  <Button secondary onClick={handleClearClick}>
                    Limpiar
                  </Button>
                  <Button
                    primary
                    onClick={handleSearchClick}
                    disabled={
                      !selectedFilters.startDate ||
                      !selectedFilters.endDate ||
                      !selectedFilters.requestType
                    }
                  >
                    Consultar
                  </Button>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      {renderTable()}
    </div>
  );
};

export default RequestsInstallationDevice;
